// Disable eslint because this code was not written with lint in mind, and was ported in. It needs to be fixed at some point.
/* eslint-disable */
import { Token } from './tokens/token';

export class RequestManager {
  private static emptyMap = new Map<string, string>();

  staging = false;

  private getAuthUrl(path: string): string {
    return `https://auth.${this.staging ? 'youversionapistaging.com' : 'youversionapi.com'}${path}`;
  }

  private getApiUrl(host: string, path: string): string {
    // TODO: Adding webproxy back until we can figure out cors
    // return `https://${host}.${this.staging ? "youversionapistaging.com" : "youversionapi.com"}${path}`;
    if (path.startsWith('/3.1/')) {
      path = path.substring('/3.1'.length);
    }
    return `https://webproxy${this.staging ? '-staging' : ''}.bible.com/${host}${path}`;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static getHeaders(headers: Map<string, string>): any {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const defaultHeaders: any = {
      Accept: 'application/json',
      'User-Agent': 'web-auth',
      Referer: 'https://web.youversionapi.com/',
      'X-YouVersion-Client': 'youversion',
      'X-YouVersion-App-Version': '1',
      'X-YouVersion-App-Platform': 'web',
    };
    for (const key of headers.keys()) {
      defaultHeaders[key] = headers.get(key);
    }
    return defaultHeaders;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async getApi(host: string, path: string, version = '3.1', token: Token | null = null): Promise<any> {
    return await this.executeApi('GET', host, path, version, token);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async postApi(host: string, path: string, version = '3.1', token: Token | null = null): Promise<any> {
    return await this.executeApi('POST', host, path, version, token);
  }

  private async executeApi(
    method: string,
    host: string,
    path: string,
    version: string,
    token: Token | null
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Promise<any> {
    const url = this.getApiUrl(host, `/${version}${path}`);
    const response = await fetch(url, {
      method: method,
      headers: RequestManager.getHeaders(
        token == null || token.header == null
          ? RequestManager.emptyMap
          : new Map<string, string>([['Authorization', token.header]])
      ),
    });

    if (!response.ok) {
      throw new Error(`Invalid request: ${response.status}`);
    }

    if (response.status == 201 || response.status == 404) {
      return null;
    }

    return await response.json();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async postForm(path: string, body: any): Promise<any> {
    const url = this.getAuthUrl(path);
    const response = await fetch(url, {
      method: 'POST',
      headers: RequestManager.getHeaders(
        new Map<string, string>([['Content-Type', 'application/x-www-form-urlencoded']])
      ),
      body: body,
    });

    if (!response.ok) {
      throw new Error(`Invalid request: ${response.status}`);
    }

    return await response.json();
  }
}
